import React, { useState, useEffect } from "react";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { motion } from "framer-motion";


import { AppWrap, MotionWrap } from "../../wrapper";
import { urlFor } from "../../client";
import useSanity from "../../customHooks/useSanity";
import "./Testimonial.scss";

const Testimonial = () => {
	const { testimonials,brands } = useSanity();
	const [currentIndex, setCurrentIndex] = useState(0);


	const handleClick = (index) => {
		setCurrentIndex(index);
	};


	return !testimonials ? (
		<>
			<></>
			{!brands ? (
				<></>
			) : (
				<>
					<h2 className="head-text">
						Brands I've worked with
					</h2>
					<div className="app__testimonial-brands app__flex">
						{brands
							.filter(
								(brand) =>
									brand.showOnFrontend === true
							) // Filter brands with showOnFrontend set to true
							.map((brand) => (
								<motion.div
									whileInView={{ opacity: [0, 1] }}
									transition={{
										duration: 0.5,
										type: "tween",
									}}
									key={brand._id}
								>
									<img
										src={urlFor(
											brand.brandLogo.asset
										).url()} // Assuming brandLogo contains the image asset
										alt={brand.brandTitle}
									/>
									<p>{brand.brandTitle}</p>
								</motion.div>
							))}
					</div>
				</>
			)}
		</>
	) : (
		<>
			<h2 className="testimonial__text head-text">
				What my clients say about me
			</h2>
			{testimonials.length && (
				<>
					<div className="app__testimonial-item app__flex">
						<img
							src={urlFor(
								testimonials[currentIndex].imgurl
							)}
							alt={testimonials[currentIndex].name}
						/>
						<div className="app__testimonial-content">
							<p className="p-text">
								{testimonials[currentIndex].feedback}
							</p>
							<div>
								<h4 className="bold-text">
									{testimonials[currentIndex].name}
								</h4>
								<h5 className="p-text">
									{
										testimonials[currentIndex]
											.company
									}
								</h5>
							</div>
						</div>
					</div>

					<div className="app__testimonial-btns app__flex">
						<div
							className="app__flex"
							onClick={() =>
								handleClick(
									currentIndex === 0
										? testimonials.length - 1
										: currentIndex - 1
								)
							}
						>
							<HiChevronLeft />
						</div>

						<div
							className="app__flex"
							onClick={() =>
								handleClick(
									currentIndex ===
										testimonials.length - 1
										? 0
										: currentIndex + 1
								)
							}
						>
							<HiChevronRight />
						</div>
					</div>
				</>
			)}
		</>
	);
}


export default AppWrap(
	MotionWrap(Testimonial, "app__testimonial"),
	"testimonial",
	"app__primarybg"
);
